












import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
let promise: any = ''

@Component({
	name: 'Upload',
})
export default class Upload extends Vue {
	@Prop()
	private accept!: any

	@Prop()
	private sizeLimit!: any

	public onSingleChange(e: any) {
		if (e.size > this.sizeLimit * 1024 * 1024) {
			promise.reject(`文件大小不能超过${this.sizeLimit || 10}M`)
			this.$message.error(`文件大小不能超过${this.sizeLimit || 10}M`)
			return false
		}
		promise.resolve(e.target.files[0])
	}

	private getSingle() {
		return new Promise((resolve: any, reject: any) => {
			const btn: any = this.$refs.btnSingle
			btn.value = ''
			promise = {
				resolve,
				reject,
			}
			btn.click()
		})
	}

	public onChange(e: any) {
		for (let file of e.target.files) {
			if (file.size > this.sizeLimit * 1024 * 1024) {
				promise.reject(`文件大小不能超过${this.sizeLimit || 10}M`)
				this.$message.error(`文件大小不能超过${this.sizeLimit || 10}M`)
				return false
			}
		}
		promise.resolve(e.target.files)
	}

	private get() {
		return new Promise((resolve: any, reject: any) => {
			const btn: any = this.$refs.btn
			btn.value = ''
			promise = {
				resolve,
				reject,
			}
			btn.click()
		})
	}
}
